import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { ConnectorPinsContext } from '../context/context'
import ItemRow from '../ItemRow'
import { useIntl } from 'react-intl'

const PinRow = (props) => {
  const intl = useIntl()
  const [state, dispatch] = useContext(ConnectorPinsContext)
  const { name, value, description, harnessName, circuitId, inputName, formRef } = props

  const checkBoxHandler = (checked) => {
    const { value, circuitId } = props

    const checkboxValue = checked

    if (checkboxValue) {
      dispatch({ type: 'selected_pins', data: `${name}**$$${circuitId}` })
    } else {
      dispatch({ type: 'selected_pins', data: `${name}**$$${circuitId}` })
    }
  }

  return (
    <ItemRow
      name={name}
      inputName={inputName}
      value={value}
      onChange={(e) => checkBoxHandler(e)}
      description={description}
      isChecked={
        state?.selected_pins?.length > 0
          ? state?.selected_pins?.includes(`${name}**$$${circuitId}`)
          : false
      }
      formRef={formRef}
    >
      {harnessName && (
        intl.formatMessage({ id: 'generic.harnessPrefix' }, { harnessName })
      )}
    </ItemRow>
  )
}

PinRow.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  description: PropTypes.string,
  harnessName: PropTypes.string,
  checked: PropTypes.bool,
  circuitId: PropTypes.string,
}

export default PinRow
